import React from 'react';
import moment from 'moment';

import Icon from '../jo-components/ui/icon/icon';
import { useTranslation } from 'react-i18next';
import QRCode from 'react-qr-code';
import Chip from '../resale/seller/components/chip';
import './ticket-menu.css';


function MyTicket({ config }) {
	const { t } = useTranslation();
	const { display_scan_status, qr_code_informations } = config || {};
	const { barcode, scan_date } = qr_code_informations || {};

	if (!barcode) {
		return null;
	}

	const isScanned = Boolean(scan_date);
	const formattedScanDate = scan_date 
		? moment(scan_date).format('DD/MM/YYYY HH:mm') 
		: null;

	return (
		<div className='wz-neo-myticket-container'>
			<h4 className='wz-neo-myticket-title'>{t('widget.ticket.my-ticket')}</h4>
			<div className='wz-neo-myticket-qrcode'>
				<QRCode value={barcode} size={185} />
				{display_scan_status && (
					<Chip 
						color={isScanned ? 'green' : 'gray'}
						icon={
							<div className={`wz-check-icon-wrapper ${isScanned ? 'scanned' : 'not-scanned'}`}>
								<Icon 
									className='wz-check-icon' 
									name={isScanned ? 'checkSimple' : 'cross'}
								/>
							</div>
						} 
						text={
							isScanned 
								? t('widget.ticket.scanned', { date: formattedScanDate }) 
								: t('widget.ticket.not-scanned')
						}
					/>
				)}
			</div>
		</div>
	);
}

export function TicketMenu({ config }) {
	const ticketMenuConfig = config?.['ticket-menu'];
	const shouldDisplayQRCode = ticketMenuConfig?.config?.display_qr_code;

	if (!shouldDisplayQRCode) {
		return null;
	}

	return <MyTicket config={ticketMenuConfig?.config} />;
}